import { useState } from 'react';
export const useSetAsSet = (initial = []) => {
    const [entries, setEntries] = useState(new Set(initial));
    return [entries, {
            has: (v) => entries.has(v),
            add: (v) => setEntries(new Set(entries.add(v))),
            delete: (v) => {
                const has = entries.delete(v);
                setEntries(new Set(entries));
                return has;
            },
            clear: () => setEntries(new Set([])),
            reset: (v) => setEntries(new Set(v)),
            toggle: (v) => {
                entries.has(v) ? entries.delete(v) : entries.add(v);
                setEntries(new Set(entries));
            }
        }];
};
